export default __webpack_public_path__ + "static/laksiprokt-a2b0b5d70b39220c0be5a85f38451055.jpg";